import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 px-2 pb-10 lg:grid-cols-2" }

import { computed } from "vue";
import { Project, ProjectThumbnailUrl } from "@/types/Project";
import ProjectCard from "@/views/dashboard/components/ProjectCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Projects',
  props: {
    projects: {},
    thumbnailUrls: {}
  },
  setup(__props: any) {

const props = __props;

const thumbnailUrlsByProject = computed(() =>
  props.thumbnailUrls.reduce((acc, projectThumbnailUrl) => {
    acc[projectThumbnailUrl._id] = projectThumbnailUrl.thumbnail_url;
    return acc;
  }, {} as Record<string, string>),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(ProjectCard, {
          id: 'project-link-' + index,
          "project-info": project,
          thumbnailUrl: thumbnailUrlsByProject.value[project._id]
        }, null, 8, ["id", "project-info", "thumbnailUrl"])
      ]))
    }), 128))
  ]))
}
}

})